exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html {\n  height: 100%; }\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  overscroll-behavior-y: none;\n  height: 100%; }\n  body strong,\n  body b {\n    font-weight: 500; }\n\n#root {\n  height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/index.scss
// module id = 904
// module chunks = 0